module.exports = __webpack_public_path__ + "static/media/bg25.7065ec59.jpg";